export const PayApplyType = {
  APPLICATION: 'APPLICATION',
  PAYMENT: 'PAYMENT',
}

export const PayApplyIdType = {
  ID: 'ID',
  PASSPORT: 'PASSPORT',
  DRIVERS_LICENCE: 'DRIVERS_LICENCE',
}
